import React from 'react'
import { Parallax } from 'react-parallax'
import Counter from './Counter'
import imgParallax from '../img/parallax.jpg'
//graphql 
import { useQuery } from '@apollo/react-hooks';
import graphql from 'graphql-tag'
import Error from './loaders/Error';
import FluidLoader from './loaders/FluidLoader';

const TreeCounter = () => {
    const { data, loading, error } = useQuery(graphql`
        query{
            counter{
                Trees
            }
        }
    `)

    if(loading) return <FluidLoader/>
    if(error) return <Error/>

    const { Trees } = data.counter

    return (
        <>
        <Parallax 
        bgImage={imgParallax}
        strength={500}>
            <div className="p-5">
                <Counter count={Trees}/>
            </div>
        </Parallax>
        </>
    )
}

export default TreeCounter
